
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promises",
      function () {
        return require("private-next-pages/promises/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promises"])
      });
    }
  